import { Card } from 'antd';
import Meta from 'antd/lib/card/Meta';
import React from 'react';
import RfidSetup from './RfidSetup';
import { CheckCircleOutlined } from '@ant-design/icons';

const RfidCard = ({ passport }) => {
  return (
    <Card className="gx-card">
      <Meta
        title={(
          <div className="gx-text-center">
            {passport.rfid_number}
          </div>
        )}
        description={(
          <>
            <CheckCircleOutlined className="gx-mr-2 gx-text-success" /> Kartu RFID telah disimpan
          </>
        )}
      />
      <div className="gx-mt-3">
        <RfidSetup passport={passport} />
      </div>
    </Card>
  );
}

export default RfidCard;